import * as React from 'react';
import { Main } from '../../../components';

const MinLayout = ({ children }: { children: React.ReactNode }) => <Main>{children}</Main>;

export default MinLayout;
